import { Link } from "react-router-dom";
import Paginate from "../../Paginate/Paginate";
import React, { useState } from "react";
import PropTypes from "prop-types";
import MDButton from "../../MDButton";
import PelakComponent from "../../Pelak/pelakComponent";
import Modal from "react-modal";
import ModalMachineTypeSingle from "../../Modal/MachineType/MachineTypeSingle";
import ModalMachineGroupSingle from "../../Modal/MachineGroup/MachineGroupSingle";
import ModalDrivers from "../../Modal/Driver/DriverModal";
import { updateMachine } from "../../../actions/machines/machines";
import { toast } from "react-toastify";
import { Datepicker } from "@ijavad805/react-datepicker";
import { jalaliToISOFixed } from "../../../extension/dateConvert";
import ModalSelectPeymankar from "../../Modal/Peymankar/PeymankarSelectModal";

const MachineListComponent = ({ lists, deleteInvoke }) => {
  MachineListComponent.propTypes = {
    lists: PropTypes.any,
    deleteInvoke: PropTypes.any,
  };
  const [openModalGroup, setOpenModalGroup] = useState(false);
  const [openModalDriver, setOpenModalDriver] = useState(false);
  const [machineType, setDataMachineType] = useState({});
  const [machineGroup, setDataMachineGroup] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentMachine, setCurrentMachine] = useState({});
  const [firstTwoDigits, setFirstTwoDigits] = useState("");
  const [middleThreeDigits, setMiddleThreeDigits] = useState("");
  const [letterDigit, setLetterDigit] = useState("");
  const [lastTwoDigits, setLastTwoDigits] = useState("");
  const [driver, setDriver] = useState([]);
  const [openModal2, setOpenModal] = useState(false);
  const [title, setTitle] = useState("");
  const [empty_weight, setEmptyWeight] = useState("");
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [start_work_date, setStartWorkDate] = useState("");
  const [contract_number, setContractNumber] = useState("");
  const [ownership_type, setOwnershipType] = useState("تملیکی");
  const [dataPeymankar , setDataPeymankar] = useState({id:"",title:""});
  const [openModalPeymankar, setOpenModalPeymankar] = useState(false);
  const openModal = (machine) => {
    setCurrentMachine(machine);
    setEmptyWeight(machine.empty_weight ?? 0);
    setLastTwoDigits(machine.pelak.slice(6, 8));
    setMiddleThreeDigits(machine.pelak.slice(3, 6));
    setLetterDigit(machine.pelak.slice(2, 3));
    setFirstTwoDigits(machine.pelak.slice(0, 2));
    setTitle(machine.name);
    setDriver(machine.drivers);
    setDataMachineGroup(machine.machine_group);
    setDataMachineType(machine.machine_type);
    setDataPeymankar(machine.peymankar);
    setStartDate(jalaliToISOFixed(machine.start_date ?? "") ?? "");
    setEndDate(jalaliToISOFixed(machine.end_date ?? "") ?? "");
    setStartWorkDate(jalaliToISOFixed(machine.start_work_date ?? "") ?? "");
    setContractNumber(machine.contract_number ?? "");
    setOwnershipType(machine.ownership_type ?? "تملیکی");
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentMachine((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const jsonData = {
      id: currentMachine.id,
      title: title,
      empty_weight: empty_weight,
      pelak: `${firstTwoDigits}${letterDigit}${middleThreeDigits}${lastTwoDigits}`,
      type_id: machineType.id || "",
      group_id: machineGroup.id || "",
      drivers: driver.map((d) => d.id),
      peymankar_id: dataPeymankar['id'],
      start_date: start_date,
      end_date: end_date,
      start_work_date: start_work_date,
      contract_number: contract_number,
      ownership_type: ownership_type,
    };
    const response = await updateMachine(jsonData);
    if (response.status === "success") {
      toast.success("ویرایش با موفقیت انجام شد");

      window.location.reload();
    } else {
      toast.error(state.message);
    }
    closeModal();
  };
  return (
    <>
      <ModalMachineTypeSingle showModal={openModal2} setShowModal={(flag) => {
        setOpenModal(flag);
      }} onSelectedIdsChange={(data) => {
        setOpenModal(false);
        setDataMachineType(data);
      }} setData={""} />
      <ModalMachineGroupSingle showModal={openModalGroup} setShowModal={(flag) => {
        setOpenModalGroup(flag);
      }} onSelectedIdsChange={(data) => {
        setOpenModalGroup(false);
        setDataMachineGroup(data);
      }} setData={""} />
      <ModalDrivers showModal={openModalDriver} setShowModal={(flag) => {
        setOpenModalDriver(flag);
      }} onSelectedIdsChange={(data) => {
        setOpenModalDriver(false);
        setDriver(data);
      }} setData={""} />
      <ModalSelectPeymankar setShowModal={(state)=>{
        setOpenModalPeymankar(state)
      }} setData={""} onSelectedIdsChange={(data)=>{
        setDataPeymankar(data);
      }} showModal={openModalPeymankar} />
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="flex items-center justify-between px-4 py-6 md:px-6 xl:px-7.5">
          <h4 className="text-xl font-semibold text-black dark:text-white text-right">
            لیست دستگاه ها
          </h4>
          <Link
            to="/machine/create"
            className="inline-flex text-sm items-center justify-center rounded-md bg-black px-2 py-3 text-center font-medium text-white hover:bg-opacity-90 lg:px-4 xl:px-6"
          >
            افزودن دستگاه جدید
          </Link>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                شناسه
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                عنوان دستگاه
              </th>

              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                پلاک
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                نوع دستگاه
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                گروه دستگاه
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                راننده ها
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                پیمانکار
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                تاریخ شروع کار
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                تاریخ شروع قرارداد
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                تاریخ پایان قرارداد
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                وزن خالی
              </th>
              <th scope="col"
                  className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                عملیات
              </th>
            </tr>
            </thead>

            <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
            {lists.data.map((driver, key) => (
              <tr key={key} className={"dark:bg-boxdark"}>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  {driver.id}
                </td>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  {driver.name}
                </td>
                <PelakComponent pelak={driver.pelak} />
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  {driver.machine_type.title === "null" ? "--" : driver.machine_type.title}
                </td>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  {driver.machine_group.title === "null" ? "--" : driver.machine_group.title}
                </td>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  <div className="flex flex-wrap justify-center gap-2">
                    {driver.drivers.map((item, key) => (
                      <span
                        key={key}
                        className="bg-blue-100  text-blue-800 dark:bg-blue-900 dark:text-blue-300 px-2 py-1 rounded-full text-xs font-medium"
                      >
                          {item.name}
                        </span>
                    ))}
                  </div>
                </td>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  {driver.peymankar?.title}
                </td>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  {driver.start_work_date}
                </td>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  {driver.start_date}
                </td>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  {driver.end_date}
                </td>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  {driver.empty_weight}
                </td>
                <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                  <div className={"gap-2 flex justify-center"}>
                    <MDButton
                      color={"info"}
                      onClick={() => openModal(driver)}
                      className="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-red text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
                      type="button"
                    >
                      ویرایش
                    </MDButton>

                    <MDButton
                      color={"error"}
                      onClick={() => deleteInvoke(driver.id)}
                      className="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-red text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
                      type="button"
                    >
                      حذف
                    </MDButton>
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>

        <Paginate links={lists.meta.links} />
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="ویرایش دستگاه"
          className="bg-white p-6 rounded-lg shadow-xl w-1/3 mx-auto mt-24"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50"
        >
          <h3 className="text-xl mb-4">ویرایش دستگاه</h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-3 gap-5">
              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  نام دستگاه
                </label>
                <input
                  required
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  name="title"
                  placeholder="..."
                  className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                />
              </div>
              <div className="flex-1 col-span-2">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  پلاک
                </label>
                <div
                  className="w-full bg-white p-2.5 text-md rounded-md border border-black relative inline-flex items-center space-x-2">
                  <div
                    className="absolute top-0 left-0 h-full w-8 bg-blue-800 rounded-l-md text-white text-xs flex flex-col justify-center items-center">
                    <span className="leading-none">IR</span>
                    <span className="leading-none">IRAN</span>
                  </div>
                  <div className="flex justify-center items-center pl-2 border-l border-black font-vazir">
                    <input
                      required
                      type="text"
                      maxLength={2}
                      value={lastTwoDigits}
                      onChange={(e) => setLastTwoDigits(e.target.value)}
                      className="text-center border border-gray-400 rounded px-1 w-12"
                    />
                  </div>
                  <div className="flex flex-grow justify-center items-center gap-5 text-center font-vazir">
                    <input
                      required
                      type="text"
                      maxLength={3}
                      value={middleThreeDigits}
                      onChange={(e) => setMiddleThreeDigits(e.target.value)}
                      className="text-center border border-gray-400 rounded px-1 w-12"
                    />
                    <input
                      required
                      type="text"
                      maxLength={1}
                      value={letterDigit}
                      onChange={(e) => setLetterDigit(e.target.value)}
                      className="text-center border border-gray-400 rounded px-1 w-12"
                    />
                    <input
                      required
                      type="text"
                      maxLength={2}
                      value={firstTwoDigits}
                      onChange={(e) => setFirstTwoDigits(e.target.value)}
                      className="text-center border border-gray-400 rounded px-1 w-12"
                    />
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  نوع دستگاه
                </label>
                <input
                  onClick={() => setOpenModal(true)}
                  type="text"
                  value={machineType.title}
                  readOnly
                  placeholder="..."
                  className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                />
              </div>
              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  گروه دستگاه
                </label>
                <input
                  onClick={() => setOpenModalGroup(true)}
                  type="text"
                  value={machineGroup.title}
                  readOnly
                  placeholder="..."
                  className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                />
              </div>
              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  نوع مالکیت
                </label>
                <select
                  value={ownership_type}
                  onChange={(e) => setOwnershipType(e.target.value)}
                  className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                >
                  <option value="تملیکی">تملیکی</option>
                  <option value="استیجاری">استیجاری</option>
                  <option value="پیمانکاری">پیمانکاری</option>
                </select>
              </div>

              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  شماره قرارداد
                </label>
                <input
                  type="text"
                  value={contract_number}
                  onChange={(e) => setContractNumber(e.target.value)}
                  placeholder="..."
                  className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                />
              </div>

              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  پیمانکار
                </label>
                <input
                  readOnly
                  onClick={()=>{
                    setOpenModalPeymankar(true);
                  }}
                  value={dataPeymankar['title']}
                  placeholder="..."
                  className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                />
              </div>

              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  تاریخ شروع قرارداد
                </label>
                <Datepicker
                  input={
                    <input
                      type="date"
                      placeholder="تاریخ شروع قرارداد"
                      className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                    />
                  }
                  adjustPosition="modal"
                  onChange={(val) => setStartDate(val.format())}
                  value={start_date}
                />
              </div>

              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  تاریخ پایان قرارداد
                </label>
                <Datepicker
                  input={
                    <input
                      type="date"
                      placeholder="تاریخ پایان قرارداد"
                      className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                    />
                  }
                  adjustPosition="modal"
                  onChange={(val) => setEndDate(val.format())}
                  value={end_date}
                />
              </div>

              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  تاریخ شروع کار
                </label>
                <Datepicker
                  input={
                    <input
                      type="date"
                      placeholder="تاریخ شروع کار"
                      className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                    />
                  }
                  adjustPosition="modal"
                  onChange={(val) => setStartWorkDate(val.format())}
                  value={start_work_date}
                />
              </div>
              <div className="flex-1 col-span-3">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  راننده ها
                </label>
                <input
                  onClick={() => setOpenModalDriver(true)}
                  type="text"
                  value={driver.map((d) => d.name).join(" - ")}
                  readOnly
                  placeholder="..."
                  className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                />
              </div>
              <div className="flex-1">
                <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                  وزن خالی
                </label>
                <input
                  required
                  type="number"
                  value={empty_weight}
                  onChange={(e) => setEmptyWeight(e.target.value)}
                  name="empty_weight"
                  placeholder="..."
                  className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                />
              </div>

            </div>
            <div className="flex justify-start gap-2 space-x-2">
              <MDButton
                color={"error"}
                onClick={closeModal}
                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
              >
                بستن
              </MDButton>
              <MDButton
                color={"success"}
                type="submit"
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
              >
                ویرایش
              </MDButton>
            </div>
          </form>
        </Modal>

      </div>

    </>
  );
};

export default MachineListComponent;